<!--修改成绩-->
<template lang="pug">
el-dialog(
  title="修改成绩",
  width="60%",
  :visible.sync="visible",
  :append-to-body="true",
  @close="closeForm()"
)
  p.title 第一双打
  .form
    el-form.chose(
      :model="dataForm",
      :rules="rules",
      ref="dataForm",
      label-suffix=":",
      label-width="200px"
    )
      el-form-item(:label="firstLabel.name1", prop="firstGainScoreSort1")
        el-input-number(
          v-model="dataForm.firstGainScoreSort1",
          :min="0",
          style="margin-left: 50px"
        )
      el-form-item(:label="firstLabel.name2", prop="secondGainScoreSort1")
        el-input-number(
          v-model="dataForm.secondGainScoreSort1",
          :min="0",
          :max="100000000",
          style="margin-left: 50px"
        )
    el-form.chose(
      :model="dataForm",
      :rules="rules",
      ref="dataForm",
      label-suffix=":",
      label-width="200px"
    )
      el-form-item(label="抢七成绩", prop="firstRobSevenScoreSort1")
        el-input-number(
          v-model="dataForm.firstRobSevenScoreSort1",
          :min="0",
          style="margin-left: 50px"
        )
      el-form-item(label="抢七成绩", prop="secondRobSevenScoreSort1")
        el-input-number(
          v-model="dataForm.secondRobSevenScoreSort1",
          :min="0",
          :max="100000000",
          style="margin-left: 50px"
        )
    el-form.chose(
      :model="dataForm",
      :rules="rules",
      ref="dataForm",
      label-suffix=":",
      label-width="50px"
    )
      el-form-item(label="", prop="")
        el-button(
          type="primary",
          @click="abstention(dataForm.firstSignNum, 1)"
        ) 一队弃权
      el-form-item(label="", prop="")
        el-button(
          type="primary",
          @click="abstention(dataForm.secondSignNum, 1)"
        ) 二队弃权
  p.title 第二双打
  .form
    el-form.chose(
      :model="dataForm",
      :rules="rules",
      ref="dataForm",
      label-suffix=":",
      label-width="200px"
    )
      el-form-item(:label="secondLabel.name1", prop="firstGainScoreSort2")
        el-input-number(
          v-model="dataForm.firstGainScoreSort2",
          :min="0",
          style="margin-left: 50px"
        )
      el-form-item(:label="secondLabel.name2", prop="secondGainScoreSort2")
        el-input-number(
          v-model="dataForm.secondGainScoreSort2",
          :min="0",
          :max="100000000",
          style="margin-left: 50px"
        )
    el-form.chose(
      :model="dataForm",
      :rules="rules",
      ref="dataForm",
      label-suffix=":",
      label-width="200px"
    )
      el-form-item(label="抢七成绩", prop="firstRobSevenScoreSort2")
        el-input-number(
          v-model="dataForm.firstRobSevenScoreSort2",
          :min="0",
          style="margin-left: 50px"
        )
      el-form-item(label="抢七成绩", prop="secondRobSevenScoreSort2")
        el-input-number(
          v-model="dataForm.secondRobSevenScoreSort2",
          :min="0",
          :max="100000000",
          style="margin-left: 50px"
        )
    el-form.chose(
      :model="dataForm",
      :rules="rules",
      ref="dataForm",
      label-suffix=":",
      label-width="50px"
    )
      el-form-item(label="", prop="")
        el-button(
          type="primary",
          @click="abstention(dataForm.firstSignNum, 2)"
        ) 一队弃权
      el-form-item(label="", prop="")
        el-button(
          type="primary",
          @click="abstention(dataForm.secondSignNum, 2)"
        ) 二队弃权
  p.title 第三双打
  .form
    el-form.chose(
      :model="dataForm",
      :rules="rules",
      ref="dataForm",
      label-suffix=":",
      label-width="200px"
    )
      el-form-item(:label="thirdLabel.name1", prop="firstGainScoreSort3")
        el-input-number(
          v-model="dataForm.firstGainScoreSort3",
          :min="0",
          style="margin-left: 50px"
        )
      el-form-item(:label="thirdLabel.name2", prop="secondGainScoreSort3")
        el-input-number(
          v-model="dataForm.secondGainScoreSort3",
          :min="0",
          :max="100000000",
          style="margin-left: 50px"
        )
    el-form.chose(
      :model="dataForm",
      :rules="rules",
      ref="dataForm",
      label-suffix=":",
      label-width="200px"
    )
      el-form-item(label="抢七成绩", prop="firstRobSevenScoreSort3")
        el-input-number(
          v-model="dataForm.firstRobSevenScoreSort3",
          :min="0",
          style="margin-left: 50px"
        )
      el-form-item(label="抢七成绩", prop="secondRobSevenScoreSort3")
        el-input-number(
          v-model="dataForm.secondRobSevenScoreSort3",
          :min="0",
          :max="100000000",
          style="margin-left: 50px"
        )
    el-form.chose(
      :model="dataForm",
      :rules="rules",
      ref="dataForm",
      label-suffix=":",
      label-width="50px"
    )
      el-form-item(label="", prop="")
        el-button(
          type="primary",
          @click="abstention(dataForm.firstSignNum, 3)"
        ) 一队弃权
      el-form-item(label="", prop="")
        el-button(
          type="primary",
          @click="abstention(dataForm.secondSignNum, 3)"
        ) 二队弃权
  span.dialog-footer(slot="footer")
    el-button(type="primary", @click="ReviseGrade", :loading="ishowbtn") 确 定
    el-button(@click="closeForm()") 取 消
</template>
<script>
import { achievementInfoWhole, abstentionResults } from "@/api/fqSelf/index.js";
export default {
  name: "UpdateGrade",
  data () {
    return {
      ishowbtn: false,
      visible: false,
      reviseFlag1: -2,
      reviseFlag2: -2,
      reviseFlag3: -2,
      rules: {
        // firstGainScoreSort1: [
        //   { required: true, message: "成绩不能为空!", trigger: "change" },
        // ],
        // secondGainScoreSort1: [
        //   { required: true, message: "成绩不能为空!", trigger: "change" },
        // ],
        // firstGainScoreSort2: [
        //   { required: true, message: "成绩不能为空!", trigger: "change" },
        // ],
        // secondGainScoreSort2: [
        //   { required: true, message: "成绩不能为空!", trigger: "change" },
        // ],
        // firstGainScoreSort3: [
        //   { required: true, message: "成绩不能为空!", trigger: "change" },
        // ],
        // secondGainScoreSort3: [
        //   { required: true, message: "成绩不能为空!", trigger: "change" },
        // ],
      },
      dataForm: {},
      firstLabel: {},
      secondLabel: {},
      thirdLabel: {},
    };
  },
  methods: {
    init (id, row, row1) {
      this.visible = true;

      this.dataForm = {
        firstGainScoreSort1: this.dealNum(row.firstGainScore),
        secondGainScoreSort1: this.dealNum(row1.firstGainScore),
        firstRobSevenScoreSort1: this.dealNum(row.firstRobSevenScore),
        secondRobSevenScoreSort1: this.dealNum(row1.firstRobSevenScore),
        firstGainScoreSort2: this.dealNum(row.secondGainScore),
        secondGainScoreSort2: this.dealNum(row1.secondGainScore),
        firstRobSevenScoreSort2: this.dealNum(row.secondRobSevenScore),
        secondRobSevenScoreSort2: this.dealNum(row1.secondRobSevenScore),
        firstGainScoreSort3: this.dealNum(row.thirdGainScore),
        secondGainScoreSort3: this.dealNum(row1.thirdGainScore),
        firstRobSevenScoreSort3: this.dealNum(row.thirdRobSevenScore),
        secondRobSevenScoreSort3: this.dealNum(row1.thirdRobSevenScore),
        firstSignNum: row.signNum,
        secondSignNum: row1.signNum,
        againstId: row.againstId,
      };
      console.log("dataForm", this.dataForm);
      console.log(
        "----",
        this.dataForm.firstSignNum,
        this.dataForm.secondSignNum
      );
      this.firstLabel = {
        name1: row.firstPairName === null ? "-" : row.firstPairName + "得分",
        name2: row1.firstPairName === null ? "-" : row1.firstPairName + "得分",
      };
      this.secondLabel = {
        name1: row.secondPairName === null ? "-" : row.secondPairName + "得分",
        name2:
          row1.secondPairName === null ? "-" : row1.secondPairName + "得分",
      };
      this.thirdLabel = {
        name1: row.thirdPairName === null ? "-" : row.thirdPairName + "得分",
        name2: row1.thirdPairName === null ? "-" : row1.thirdPairName + "得分",
      };
      this.reviseFlag1 = -2;
      this.reviseFlag2 = -2;
      this.reviseFlag3 = -2;
      if (this.dataForm.firstGainScoreSort1 != undefined && this.dataForm.secondGainScoreSort1 != undefined) {  
        this.reviseFlag1 = 1
        if (this.dataForm.firstGainScoreSort1 == "弃") { 
          if (this.dataForm.secondGainScoreSort1 == "弃") { 
            this.reviseFlag1 = 0
          } else {
            this.reviseFlag1 = -1
          }
        } else if (this.dataForm.secondGainScoreSort1 != "弃" && 
                this.dataForm.firstGainScoreSort1 < this.dataForm.secondGainScoreSort1
        ) {
            this.reviseFlag1 = -1
        }
      };  
      if (this.dataForm.firstGainScoreSort2 != undefined && this.dataForm.secondGainScoreSort2 != undefined) {  
        this.reviseFlag2 = 1
        if (this.dataForm.firstGainScoreSort2 == "弃") { 
          if (this.dataForm.secondGainScoreSort2 == "弃") { 
            this.reviseFlag2 = 0
          } else {
            this.reviseFlag2 = -1
          }
        } else if (this.dataForm.secondGainScoreSort2 != "弃" && 
                this.dataForm.firstGainScoreSort2 < this.dataForm.secondGainScoreSort2
        ) {
            this.reviseFlag2 = -1
        }
      }; 
      if (this.dataForm.firstGainScoreSort3 != undefined && this.dataForm.secondGainScoreSort3 != undefined) {  
        this.reviseFlag3 = 1
        if (this.dataForm.firstGainScoreSort3 == "弃") { 
          if (this.dataForm.secondGainScoreSort3 == "弃") { 
            this.reviseFlag3 = 0
          } else {
            this.reviseFlag3 = -1
          }
        } else if (this.dataForm.secondGainScoreSort3 != "弃" && 
                this.dataForm.firstGainScoreSort3 < this.dataForm.secondGainScoreSort3
        ) {
            this.reviseFlag3 = -1
        }
      };                 
    },
    ReviseGrade () {
      console.log(this.dataForm);
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.dataForm.firstGainScoreSort1 != "弃") {
            if (
              this.dataForm.firstGainScoreSort1 ===
                this.dataForm.secondGainScoreSort1 &&
              this.dataForm.firstGainScoreSort1 != undefined &&
              this.dataForm.firstGainScoreSort1 != undefined
            ) {
              return this.$message.error("分数不可相同！");
            }
          }

          if (this.dataForm.firstGainScoreSort2 != "弃") {
            if (
              this.dataForm.firstGainScoreSort2 ===
                this.dataForm.secondGainScoreSort2 &&
              this.dataForm.firstGainScoreSort2 != undefined &&
              this.dataForm.firstGainScoreSort2 != undefined
            ) {
              return this.$message.error("分数不可相同！");
            }
          }

          if (this.dataForm.firstGainScoreSort3 != "弃") {
            if (
              this.dataForm.firstGainScoreSort3 ===
                this.dataForm.secondGainScoreSort3 &&
              this.dataForm.firstGainScoreSort3 != undefined &&
              this.dataForm.secondGainScoreSort3 != undefined
            ) {
              return this.$message.error("分数不可相同！");
            }
          }

          if (
            ((this.dataForm.firstRobSevenScoreSort1 ||
              this.dataForm.firstRobSevenScoreSort1 == 0) &&
              (this.dataForm.secondRobSevenScoreSort1 ||
                this.dataForm.secondRobSevenScoreSort1 == 0) &&
              this.dataForm.firstRobSevenScoreSort1 ===
                this.dataForm.secondRobSevenScoreSort1) ||
            ((this.dataForm.firstRobSevenScoreSort2 ||
              this.dataForm.firstRobSevenScoreSort2 == 0) &&
              (this.dataForm.secondRobSevenScoreSort2 ||
                this.dataForm.secondRobSevenScoreSort2 == 0) &&
              this.dataForm.firstRobSevenScoreSort2 ===
                this.dataForm.secondRobSevenScoreSort2) ||
            ((this.dataForm.firstRobSevenScoreSort3 ||
              this.dataForm.firstRobSevenScoreSort3 == 0) &&
              (this.dataForm.secondRobSevenScoreSort3 ||
                this.dataForm.secondRobSevenScoreSort3 == 0) &&
              this.dataForm.firstRobSevenScoreSort3 ===
                this.dataForm.secondRobSevenScoreSort3)
          ) {
            return this.$message.error("抢七成绩不可相同！");
          }
          if (
            ((this.dataForm.firstRobSevenScoreSort1 ||
              this.dataForm.firstRobSevenScoreSort1 == 0) &&
              !(
                this.dataForm.secondRobSevenScoreSort1 ||
                this.dataForm.secondRobSevenScoreSort1 == 0
              )) ||
            (!(
              this.dataForm.firstRobSevenScoreSort1 ||
              this.dataForm.firstRobSevenScoreSort1 == 0
            ) &&
              (this.dataForm.secondRobSevenScoreSort1 ||
                this.dataForm.secondRobSevenScoreSort1 == 0)) ||
            ((this.dataForm.firstRobSevenScoreSort2 ||
              this.dataForm.firstRobSevenScoreSort2 == 0) &&
              !(
                this.dataForm.secondRobSevenScoreSort2 ||
                this.dataForm.secondRobSevenScoreSort2 == 0
              )) ||
            (!(
              this.dataForm.firstRobSevenScoreSort2 ||
              this.dataForm.firstRobSevenScoreSort2 == 0
            ) &&
              (this.dataForm.secondRobSevenScoreSort2 ||
                this.dataForm.secondRobSevenScoreSort2 == 0)) ||
            ((this.dataForm.firstRobSevenScoreSort3 ||
              this.dataForm.firstRobSevenScoreSort3 == 0) &&
              !(
                this.dataForm.secondRobSevenScoreSort3 ||
                this.dataForm.secondRobSevenScoreSort3 == 0
              )) ||
            (!(
              this.dataForm.firstRobSevenScoreSort3 ||
              this.dataForm.firstRobSevenScoreSort3 == 0
            ) &&
              (this.dataForm.secondRobSevenScoreSort3 ||
                this.dataForm.secondRobSevenScoreSort3 == 0))
          ) {
            return this.$message.error("抢七成绩不可一方为空！");
          }

          if (
            (this.reviseFlag1 == -1 && 
                (this.dataForm.secondGainScoreSort1 != '弃' && this.dataForm.firstGainScoreSort1 > this.dataForm.secondGainScoreSort1)
            ) ||
              (this.reviseFlag1 == 1 && 
                (this.dataForm.firstGainScoreSort1 != '弃' && this.dataForm.firstGainScoreSort1 < this.dataForm.secondGainScoreSort1)
            ) ||            
              (this.reviseFlag2 == -1 && 
                  (this.dataForm.secondGainScoreSort2 != '弃' && this.dataForm.firstGainScoreSort2 > this.dataForm.secondGainScoreSort2)
            ) ||
              (this.reviseFlag2 == 1 && 
                  (this.dataForm.firstGainScoreSort2 != '弃' && this.dataForm.firstGainScoreSort2 < this.dataForm.secondGainScoreSort2)
            ) ||            
              (this.reviseFlag3 == -1 && 
                  (this.dataForm.secondGainScoreSort3 != '弃' && this.dataForm.firstGainScoreSort3 > this.dataForm.secondGainScoreSort3)
              ) ||
              (this.reviseFlag3 == 1 && 
                  (this.dataForm.firstGainScoreSort3 != '弃' && this.dataForm.firstGainScoreSort3 < this.dataForm.secondGainScoreSort3)
              ) 
          ) {
              const h = this.$createElement
              this.$msgbox({
                title: '提示',
                message: h('p', null, [
                  h('p', '修改当前成绩已经更改胜负关系，'),
                  h('p', '后续选手对阵会被清空，'),
                  h('p', '烦请仔细核对并且确认风险。')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',    
                customClass: 'custom-msgbox',  
                type: 'warning'
              })
                .then(() => {
                  this.ReviseGradeReq()
                })  
          } else {
            this.ReviseGradeReq()
          } 
        }
      })
    },
    ReviseGradeReq () {
      this.ishowbtn = true;
      console.log("---------", this.dataForm);
      // if (!this.dataForm.firstGainScoreSort1)
      //   this.dataForm.firstGainScoreSort1 = "";

      // if (!this.dataForm.secondGainScoreSort1)
      //   this.dataForm.secondGainScoreSort1 = "";

      // if (!this.dataForm.firstGainScoreSort2)
      //   this.dataForm.firstGainScoreSort2 = "";

      // if (!this.dataForm.secondGainScoreSort2)
      //   this.dataForm.secondGainScoreSort2 = "";

      // if (!this.dataForm.firstGainScoreSort3)
      //   this.dataForm.firstGainScoreSort3 = "";

      // if (!this.dataForm.secondGainScoreSort3)
      //   this.dataForm.secondGainScoreSort3 = "";
      achievementInfoWhole(this.dataForm).then((data) => {
        if (data && data.code === 0) {
          this.visible = false;
          this.ishowbtn = false;
          this.$emit("refreshList");          
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 1500,
            onClose: () => {
              // this.visible = false;
              // this.ishowbtn = false;
              // this.$emit("refreshList");
            },
          });
        } else {
          this.ishowbtn = false;
        }
      })
    },
    ResetDataform () {
      this.dataForm = {
        firstGainScoreSort1: '',
        secondGainScoreSort1: '',
        firstRobSevenScoreSort1: '',
        secondRobSevenScoreSort1: '',
        firstGainScoreSort2: '',
        secondGainScoreSort2: '',
        firstRobSevenScoreSort2: '',
        secondRobSevenScoreSort2: '',
        firstGainScoreSort3: '',
        secondGainScoreSort3: '',
        firstRobSevenScoreSort3: '',
        secondRobSevenScoreSort3: '',
        firstSignNum: '',
        secondSignNum: '',
        againstId: '',
      }
    },
    abstention (signNum, doubleSort) {
      console.log(this.dataForm.againstId, signNum, doubleSort);
      if (doubleSort == 1) {
        if ((signNum == this.dataForm.firstSignNum && this.reviseFlag1 == 1) ||
            (signNum == this.dataForm.secondSignNum && this.reviseFlag1 == -1)) {
              const h = this.$createElement
              this.$msgbox({
                title: '提示',
                message: h('p', null, [
                  h('p', '修改当前成绩已经更改胜负关系，'),
                  h('p', '后续选手对阵会被清空，'),
                  h('p', '烦请仔细核对并且确认风险。')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',    
                customClass: 'custom-msgbox',  
                type: 'warning'
              })
                .then(() => {
                  this.abstentionReq(signNum, doubleSort)
                }) 
        } else {
          this.abstentionReq(signNum, doubleSort)
        }
      } else if (doubleSort == 2) {  
        if ((signNum == this.dataForm.firstSignNum && this.reviseFlag2 == 1) ||
            (signNum == this.dataForm.secondSignNum && this.reviseFlag2 == -1)) {
              const h = this.$createElement
              this.$msgbox({
                title: '提示',
                message: h('p', null, [
                  h('p', '修改当前成绩已经更改胜负关系，'),
                  h('p', '后续选手对阵会被清空，'),
                  h('p', '烦请仔细核对并且确认风险。')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',    
                customClass: 'custom-msgbox',  
                type: 'warning'
              })
                .then(() => {
                  this.abstentionReq(signNum, doubleSort)
                }) 
        } else {
          this.abstentionReq(signNum, doubleSort)
        }
      } else {
        if ((signNum == this.dataForm.firstSignNum && this.reviseFlag3 == 1) ||
            (signNum == this.dataForm.secondSignNum && this.reviseFlag3 == -1)) {
              const h = this.$createElement
              this.$msgbox({
                title: '提示',
                message: h('p', null, [
                  h('p', '修改当前成绩已经更改胜负关系，'),
                  h('p', '后续选手对阵会被清空，'),
                  h('p', '烦请仔细核对并且确认风险。')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',    
                customClass: 'custom-msgbox',  
                type: 'warning'
              })
                .then(() => {
                  this.abstentionReq(signNum, doubleSort)
                }) 
        } else {
          this.abstentionReq(signNum, doubleSort)
        }
      }
    },
    abstentionReq (signNum, doubleSort) {
      console.log(this.dataForm.againstId, signNum, doubleSort);
      abstentionResults(this.dataForm.againstId, signNum, doubleSort).then(
        (data) => {
          console.log(data);
          if (data && data.code == 0) {
            this.$message.success(data.data);
            this.visible = false;
            this.ishowbtn = false;
            this.$emit("refreshList");
          }
        }
      );
    },    
    closeForm() {
      this.visible = false;
      this.ResetDataform();
    },
    dealNum(value) {
      return value === null ? undefined : value;
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.title {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #333;
  margin-left: 20px;
}
.chose {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.custom-msgbox .el-button{
    background-color: rgb(2,185,13); 
    border-color: rgb(2,185,13); 
    color: white; 
}
.custom-msgbox .el-button--primary {
  margin-right: 10px;
  float:left;
  background-color: white;
  border-color:grey;
  color: black;
}
</style>
